import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import OrbisSpinner from '@/components/ui/orbis-spinner';

/**
 * Landing page after Google OAuth redirect.
 * Reads ?token= from the URL, stores it, then navigates to /dashboard.
 */
export default function GoogleCallbackPage() {
  const navigate        = useNavigate();
  const [searchParams]  = useSearchParams();
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      toast.error('Google sign-in failed — please try again');
      navigate('/login', { replace: true });
      return;
    }

    if (token) {
      loginWithToken(token);
      toast.success('Welcome!');
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center"
      style={{ background: 'var(--orbis-bg)' }}>
      <div className="flex flex-col items-center gap-4">
        <OrbisSpinner size={48} />
        <p style={{ fontSize: 14, color: 'var(--orbis-t3)' }}>Signing you in…</p>
      </div>
    </div>
  );
}
